import classNames from 'classnames';

import './DangerousHTML.scss';

interface Props {
  content: string;
  className?: string;
}

export const DangerousHTML: React.FC<Props> = ({ content, className }) => {
  return (
    <div className={classNames('dangerously-html-content', className)} dangerouslySetInnerHTML={{ __html: content }} />
  );
};
